"use strict";
/**
 * @author Zhoukai
 * @date 2021/9/8
 * @time 5:58 下午
 * @fileName CalcProfitUtils.tsx
 * @Description: 计算利润
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports._calcGridV4Profit = exports._calcEnhancedAipProfit = exports._calcSCProfit = exports._calcMTGProfit = exports._calcSRProfit = exports._calcReverseFSAProfit = exports._calcCMFSAProfit = exports._calcFSAProfit = exports._calcSmartTradeProfit = exports._calcTrailingStopProfit = exports._calcGridProProfit = exports._calcTotalCostByEarnQuote = exports._calcTotalCostByEarnBase = exports._calcGridProfitByEarnBase = exports._calcGridProfitByEarnQuote = exports._calcGridProfit = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
const Macro_1 = require("./Macro");
const TradeUtils_1 = require("./TradeUtils");
/**
 * 传统网格 和ig订单 计算利润
 * @param item
 * @param price
 * @private
 */
function _calcGridProfit(item, price) {
    let closedPrice = price;
    if (!item.isRunning) {
        switch (item.orderType) {
            case TradeTypeDef_1.OrderTypeDesc.GRID:
                closedPrice = item.exchangeGridOrder.closedPrice || item.exchangeGridOrder.latestPrice || price;
                break;
            case TradeTypeDef_1.OrderTypeDesc.IG:
                item.exchangeIGOrder.latestPrice = price;
                closedPrice = item.exchangeIGOrder.closedPrice || item.exchangeIGOrder.latestPrice || price;
                break;
            default:
                break;
        }
    }
    if (item.state !== "submitted" && closedPrice !== undefined && !isNaN(closedPrice)) {
        switch (item.orderType) {
            case TradeTypeDef_1.OrderTypeDesc.GRID:
                if (item.exchangeGridOrder.latestBaseAmount === 0 && item.exchangeGridOrder.latestQuoteAmount === 0) {
                    item.exchangeGridOrder.totalProfit = 0;
                    item.exchangeGridOrder.puredTotalProfit = 0;
                }
                else {
                    item.exchangeGridOrder.totalProfit =
                        closedPrice * item.exchangeGridOrder.latestBaseAmount +
                            item.exchangeGridOrder.latestQuoteAmount -
                            item.exchangeGridOrder.totalInvest;
                    item.exchangeGridOrder.puredTotalProfit = item.exchangeGridOrder.totalProfit;
                }
                break;
            case TradeTypeDef_1.OrderTypeDesc.IG:
                if (item.exchangeIGOrder.latestBaseAmount === 0 && item.exchangeIGOrder.latestQuoteAmount === 0) {
                    item.exchangeIGOrder.totalProfit = 0;
                    item.exchangeIGOrder.puredTotalProfit = 0;
                }
                else {
                    item.exchangeIGOrder.totalProfit =
                        closedPrice * item.exchangeIGOrder.latestBaseAmount +
                            item.exchangeIGOrder.latestQuoteAmount -
                            item.exchangeIGOrder.totalInvest;
                    item.exchangeIGOrder.puredTotalProfit = item.exchangeIGOrder.totalProfit;
                }
                break;
            default:
                break;
        }
    }
    else {
        switch (item.orderType) {
            case TradeTypeDef_1.OrderTypeDesc.GRID:
                if (item.exchangeGridOrder.latestBaseAmount === 0 && item.exchangeGridOrder.latestQuoteAmount === 0) {
                    item.exchangeGridOrder.totalProfit = 0;
                    item.exchangeGridOrder.puredTotalProfit = 0;
                }
                else {
                    item.exchangeGridOrder.totalProfit =
                        price * item.exchangeGridOrder.latestBaseAmount +
                            item.exchangeGridOrder.latestQuoteAmount -
                            item.exchangeGridOrder.totalInvest;
                    item.exchangeGridOrder.puredTotalProfit = item.exchangeGridOrder.totalProfit;
                }
                break;
            case TradeTypeDef_1.OrderTypeDesc.IG:
                if (item.exchangeIGOrder.latestBaseAmount === 0 && item.exchangeIGOrder.latestQuoteAmount === 0) {
                    item.exchangeIGOrder.totalProfit = 0;
                    item.exchangeIGOrder.puredTotalProfit = 0;
                }
                else {
                    item.exchangeIGOrder.totalProfit =
                        price * item.exchangeIGOrder.latestBaseAmount +
                            item.exchangeIGOrder.latestQuoteAmount -
                            item.exchangeIGOrder.totalInvest;
                    item.exchangeIGOrder.puredTotalProfit = item.exchangeIGOrder.totalProfit;
                }
                break;
            default:
                break;
        }
    }
    let feeCost = 0;
    let feeRefund = 0;
    let puredFeeCost = 0;
    let puredFeeRefund = 0;
    switch (item.orderType) {
        case TradeTypeDef_1.OrderTypeDesc.GRID:
            if (item.exchangeGridOrder.userDefineFeeRate === null || (0, Macro_1.isPionex)(item.exchange)) {
                feeCost = item.exchangeGridOrder.totalFeeInQuote;
                puredFeeCost = item.exchangeGridOrder.puredFeeInQuote;
            }
            else {
                feeCost = item.exchangeGridOrder.userDefineFeeRate * item.exchangeGridOrder.totalCost;
                puredFeeCost = item.exchangeGridOrder.userDefineFeeRate * item.exchangeGridOrder.puredCost;
            }
            if (item.exchangeGridOrder.totalFeeRefundInQuote) {
                feeRefund = item.exchangeGridOrder.totalFeeRefundInQuote;
            }
            if (item.exchangeGridOrder.puredFeeRefundInQuote) {
                puredFeeRefund = item.exchangeGridOrder.puredFeeRefundInQuote;
            }
            item.exchangeGridOrder.totalProfitPercent =
                item.exchangeGridOrder.totalInvest === 0
                    ? 0
                    : (item.exchangeGridOrder.totalProfit * 100) / item.exchangeGridOrder.totalInvest;
            item.exchangeGridOrder.gridProfit = item.exchangeGridOrder.gridProfitOriginal - feeCost + feeRefund;
            item.exchangeGridOrder.gridProfitPercent =
                item.exchangeGridOrder.totalInvest === 0
                    ? 0
                    : (item.exchangeGridOrder.gridProfit * 100) / item.exchangeGridOrder.totalInvest;
            item.exchangeGridOrder.unrealizedProfit = item.exchangeGridOrder.totalProfit - item.exchangeGridOrder.gridProfit;
            item.exchangeGridOrder.unrealizedProfitPercent =
                item.exchangeGridOrder.totalInvest === 0
                    ? 0
                    : (item.exchangeGridOrder.unrealizedProfit * 100) / item.exchangeGridOrder.totalInvest;
            //适配 2019年8月9日 12点之前的订单
            if (item.timestamp > 1565323200000) {
                item.exchangeGridOrder.puredTotalProfitPercent =
                    item.exchangeGridOrder.totalInvest === 0
                        ? 0
                        : (item.exchangeGridOrder.puredTotalProfit * 100) / item.exchangeGridOrder.totalInvest;
                item.exchangeGridOrder.puredGridProfit = item.exchangeGridOrder.puredGridProfitOriginal - puredFeeCost + puredFeeRefund;
                item.exchangeGridOrder.puredGridProfitPercent =
                    item.exchangeGridOrder.totalInvest === 0
                        ? 0
                        : (item.exchangeGridOrder.puredGridProfit * 100) / item.exchangeGridOrder.totalInvest;
                item.exchangeGridOrder.puredUnrealizedProfit =
                    item.exchangeGridOrder.puredTotalProfit - item.exchangeGridOrder.puredGridProfit;
                item.exchangeGridOrder.puredUnrealizedProfitPercent =
                    item.exchangeGridOrder.totalInvest === 0
                        ? 0
                        : (item.exchangeGridOrder.puredUnrealizedProfit * 100) / item.exchangeGridOrder.totalInvest;
            }
            else {
                item.exchangeGridOrder.puredTotalProfit = item.exchangeGridOrder.totalProfit;
                item.exchangeGridOrder.puredTotalProfitPercent = item.exchangeGridOrder.totalProfitPercent;
                item.exchangeGridOrder.puredGridProfit = item.exchangeGridOrder.gridProfit;
                item.exchangeGridOrder.puredGridProfitPercent = item.exchangeGridOrder.gridProfitPercent;
                item.exchangeGridOrder.puredUnrealizedProfit = item.exchangeGridOrder.unrealizedProfit;
                item.exchangeGridOrder.puredUnrealizedProfitPercent = item.exchangeGridOrder.puredUnrealizedProfit;
            }
            break;
        case TradeTypeDef_1.OrderTypeDesc.IG:
            if (item.exchangeIGOrder.userDefineFeeRate === null || (0, Macro_1.isPionex)(item.exchange)) {
                feeCost = item.exchangeIGOrder.totalFeeInQuote;
                puredFeeCost = item.exchangeIGOrder.puredFeeInQuote;
            }
            else {
                feeCost = item.exchangeIGOrder.userDefineFeeRate * item.exchangeIGOrder.totalCost;
                puredFeeCost = item.exchangeIGOrder.userDefineFeeRate * item.exchangeIGOrder.puredCost;
            }
            if (item.exchangeIGOrder.totalFeeRefundInQuote) {
                feeRefund = item.exchangeIGOrder.totalFeeRefundInQuote;
            }
            if (item.exchangeIGOrder.puredFeeRefundInQuote) {
                puredFeeRefund = item.exchangeIGOrder.puredFeeRefundInQuote;
            }
            item.exchangeIGOrder.totalProfitPercent =
                item.exchangeIGOrder.totalInvest === 0 ? 0 : (item.exchangeIGOrder.totalProfit * 100) / item.exchangeIGOrder.totalInvest;
            item.exchangeIGOrder.profit = item.exchangeIGOrder.profitOriginal - feeCost + feeRefund;
            item.exchangeIGOrder.profitPercent =
                item.exchangeIGOrder.totalInvest === 0 ? 0 : (item.exchangeIGOrder.profit * 100) / item.exchangeIGOrder.totalInvest;
            item.exchangeIGOrder.unrealizedProfit = item.exchangeIGOrder.totalProfit - item.exchangeIGOrder.profit;
            item.exchangeIGOrder.unrealizedProfitPercent =
                item.exchangeIGOrder.totalInvest === 0
                    ? 0
                    : (item.exchangeIGOrder.unrealizedProfit * 100) / item.exchangeIGOrder.totalInvest;
            if (item.timestamp > 1565323200000) {
                item.exchangeIGOrder.puredTotalProfitPercent =
                    item.exchangeIGOrder.totalInvest === 0
                        ? 0
                        : (item.exchangeIGOrder.puredTotalProfit * 100) / item.exchangeIGOrder.totalInvest;
                item.exchangeIGOrder.puredProfit = item.exchangeIGOrder.puredProfitOrigin - puredFeeCost + puredFeeRefund;
                item.exchangeIGOrder.puredProfitPercent =
                    item.exchangeIGOrder.totalInvest === 0
                        ? 0
                        : (item.exchangeIGOrder.puredProfit * 100) / item.exchangeIGOrder.totalInvest;
                item.exchangeIGOrder.puredUnrealizedProfit = item.exchangeIGOrder.puredTotalProfit - item.exchangeIGOrder.puredProfit;
                item.exchangeIGOrder.puredUnrealizedProfitPercent =
                    item.exchangeIGOrder.totalInvest === 0
                        ? 0
                        : (item.exchangeIGOrder.puredUnrealizedProfit * 100) / item.exchangeIGOrder.totalInvest;
            }
            else {
                item.exchangeIGOrder.puredTotalProfit = item.exchangeIGOrder.totalProfit;
                item.exchangeIGOrder.puredTotalProfitPercent = item.exchangeIGOrder.totalProfitPercent;
                item.exchangeIGOrder.puredProfit = item.exchangeIGOrder.profit;
                item.exchangeIGOrder.puredProfitPercent = item.exchangeIGOrder.profitPercent;
                item.exchangeIGOrder.puredUnrealizedProfit = item.exchangeIGOrder.unrealizedProfit;
                item.exchangeIGOrder.puredUnrealizedProfitPercent = item.exchangeIGOrder.puredProfitPercent;
            }
            break;
        default:
            break;
    }
    return item;
}
exports._calcGridProfit = _calcGridProfit;
/**
 * GRID_PRO
 * 和GRID_CLASSIC
 * 和GRID_LOAN: "loan_grid", // 借贷网格
 * 和GRID_SHORT: "short_grid", // 做空网格
 * 和GRID_LEVERAGE: "leverage_grid", //杠杆网格 计算利润
 * @param item
 * @param innerStatus
 * @param price
 * @private
 *
 * GRID_STATUS_MAP = {
 * 'prepare': 'prepare',
 * 'lock_currency': 'open',
 * 'assets_allocation': 'open',
 * 'fee_allocation': 'open',
 * 'open_position': 'open',
 * 'init_grid': 'open',
 * 'running': 'open',
 * 'liquidating': 'open',
 * 'close_position': 'canceling',
 * 'canceled': 'canceled',
 * 'condition_lock': 'open'}
 *
 *
 * 网格2.0 当前资产计算规则
 * 赚quote
 * init_total_balance = open_price * base_total_investment + quote_total_investment
 * current_total_balance = base_total_amount * current_price + quote_total_amount
 * total_profit = current_total_balance - init_total_balance
 *
 *
 * 赚base
 * init_total_balance =  quote_total_investment / open_price + base_total_investment
 * current_total_balance = quote_total_amount / current_price + base_total_amount
 * total_profit = current_total_balance - init_total_balance
 *
 * Leverage short pro 和classic  利润算法
 * trend 为 long 的情况（看多）:
 * 成本 = open_price * base_total_investment + quote_total_investment
 * 总利润 =  （base_total_amount * current_price + quote_total_amount）- （ open_price * base_total_investment + quote_total_investment）
 * 网格利润 = grid_profit - paired_fee_in_quote
 * 浮动盈亏 = 总利润 - 网格利润
 *
 * trend 为 short 的情况（看空）:
 * 成本 = quote_total_investment / open_price + base_total_investment
 * 总利润 =  （quote_total_amount / current_price + base_total_amount）- （ quote_total_investment /open_price  + base_total_investment）
 * 网格利润 = grid_profit / currentPrice - paired_fee_in_base
 * 浮动盈亏 = 总利润 - 网格利润
 *
 * Loan 利润算法
 * 赚base
 * 成本 = quote_total_investment / open_price + base_total_investment
 * 总利润 =  (quote_total_amount / current_price + base_total_amount）- （ quote_total_investment /open_price  + base_total_investment）)
 * 网格利润 = (grid_profit  / current_price - paired_fee_in_base)
 * 浮动盈亏 = 总利润 - 网格利润
 * 赚quote
 * 成本 = open_price * base_total_investment + quote_total_investment
 * 总利润 =  (base_total_amount * current_price + quote_total_amount）- （ open_price * base_total_investment + quote_total_investment)
 * 网格利润 = (grid_profit - paired_fee_in_quote)
 * 浮动盈亏 = (总利润 - 网格利润)
 *
 */
function _calcGridProfitByEarnQuote(item, innerStatus, price) {
    let tempTotalProfit = 0;
    let tempGridProProfit = 0;
    item.latestPrice = price;
    if (item.totalCost === 0 || price === 0 || innerStatus === TradeTypeDef_1.OrderInnerStatus.lockCurrency) {
        tempTotalProfit = 0;
    }
    else {
        tempTotalProfit = item.latestBaseAmount * price + item.latestQuoteAmount - item.totalCost;
    }
    tempGridProProfit = item.gridProfitOriginal - item.pairedFeeInQuote;
    item.gridProfit = tempGridProProfit;
    if (item.totalCost === 0 || tempTotalProfit === 0) {
        item.unRealizedProfit = 0;
    }
    else {
        item.unRealizedProfit = tempTotalProfit - tempGridProProfit;
    }
    item.totalProfit = tempTotalProfit;
    item.gridProfitPercent = item.totalCost === 0 ? 0 : (item.gridProfit * 100) / item.totalCost;
    item.unrealizedProfitPercent = item.totalCost === 0 ? 0 : (item.unRealizedProfit * 100) / item.totalCost;
    item.totalProfitPercent = item.totalCost === 0 ? 0 : (item.totalProfit * 100) / item.totalCost;
    return item;
}
exports._calcGridProfitByEarnQuote = _calcGridProfitByEarnQuote;
function _calcGridProfitByEarnBase(item, innerStatus, price) {
    let tempTotalProfit = 0;
    let tempGridProProfit = 0;
    item.latestPrice = price;
    if (price === 0 || item.initPrice === 0) {
        tempTotalProfit = 0;
    }
    else {
        if (item.totalCost === 0 || innerStatus === TradeTypeDef_1.OrderInnerStatus.lockCurrency) {
            tempTotalProfit = 0;
        }
        else {
            tempTotalProfit = item.latestQuoteAmount / price + item.latestBaseAmount - item.totalCost;
        }
    }
    if (price === 0) {
        tempGridProProfit = 0;
    }
    else {
        tempGridProProfit = item.gridProfitOriginal / price - item.pairedFeeInBase;
    }
    item.gridProfit = tempGridProProfit;
    if (item.totalCost === 0 || tempTotalProfit === 0) {
        item.unRealizedProfit = 0;
    }
    else {
        item.unRealizedProfit = tempTotalProfit - tempGridProProfit;
    }
    item.totalProfit = tempTotalProfit;
    item.gridProfitPercent = item.totalCost === 0 ? 0 : (item.gridProfit * 100) / item.totalCost;
    item.unrealizedProfitPercent = item.totalCost === 0 ? 0 : (item.unRealizedProfit * 100) / item.totalCost;
    item.totalProfitPercent = item.totalCost === 0 ? 0 : (item.totalProfit * 100) / item.totalCost;
    return item;
}
exports._calcGridProfitByEarnBase = _calcGridProfitByEarnBase;
function _calcTotalCostByEarnBase(initBaseAmount, initPrice, conditionPrice, initQuoteAmount) {
    let tempTotalCost = 0;
    if (initPrice === 0) {
        tempTotalCost = 0;
    }
    else {
        if (conditionPrice !== undefined) {
            tempTotalCost = initQuoteAmount / conditionPrice + initBaseAmount;
        }
        else {
            tempTotalCost = initQuoteAmount / initPrice + initBaseAmount;
        }
    }
    return tempTotalCost;
}
exports._calcTotalCostByEarnBase = _calcTotalCostByEarnBase;
function _calcTotalCostByEarnQuote(initBaseAmount, initPrice, conditionPrice, initQuoteAmount) {
    return initBaseAmount * (conditionPrice !== null && conditionPrice !== void 0 ? conditionPrice : initPrice) + initQuoteAmount;
}
exports._calcTotalCostByEarnQuote = _calcTotalCostByEarnQuote;
function _calcGridProProfit(item, price) {
    const innerOrder = TradeUtils_1.TradeUtils.getInnerOrder(item);
    let tempPrice = price;
    if (!item.isRunning) {
        tempPrice = innerOrder.closedPrice || price;
    }
    switch (item.orderType) {
        case TradeTypeDef_1.ExchangeOrderType.gridPro:
            item.exchangeGridProOrder = _calcGridProfitByEarnQuote(innerOrder, item.innerStatus, tempPrice);
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridV3:
            item.exchangeGridV3Order = _calcGridProfitByEarnQuote(innerOrder, item.innerStatus, tempPrice);
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridV4:
            item.exchangeGridV4Order = _calcGridV4Profit(innerOrder, item.innerStatus, tempPrice);
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridLeverage:
            if (item.exchangeLeverageGridOrder.trend === TradeTypeDef_1.GRID_TREND.short) {
                item.exchangeLeverageGridOrder = _calcGridProfitByEarnBase(innerOrder, item.innerStatus, tempPrice);
            }
            else {
                item.exchangeLeverageGridOrder = _calcGridProfitByEarnQuote(innerOrder, item.innerStatus, tempPrice);
            }
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridFuture:
            item.exchangeFutureGridOrder = _calcGridProfitByEarnQuote(innerOrder, item.innerStatus, tempPrice);
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridLoan:
            if (item.exchangeLoanGridOrder.earnCoin === item.base) {
                item.exchangeLoanGridOrder = _calcGridProfitByEarnBase(innerOrder, item.innerStatus, tempPrice);
            }
            else {
                item.exchangeLoanGridOrder = _calcGridProfitByEarnQuote(innerOrder, item.innerStatus, tempPrice);
            }
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridShort: {
            item.exchangeShortGridOrder = _calcGridProfitByEarnBase(innerOrder, item.innerStatus, tempPrice);
            break;
        }
        case TradeTypeDef_1.ExchangeOrderType.gridClassic:
            item.exchangeGridClassicOrder = _calcGridProfitByEarnQuote(innerOrder, item.innerStatus, tempPrice);
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridLeverageShort:
            item.exchangeLeverageShortGridOrder = _calcGridProfitByEarnBase(innerOrder, item.innerStatus, tempPrice);
            break;
        default:
            break;
    }
    return item;
}
exports._calcGridProProfit = _calcGridProProfit;
/**
 *  TrailingStop 订单计算利润
 * @param item
 * @param price
 * @private
 */
function _calcTrailingStopProfit(item, price) {
    const haveBase = item.exchangeTrailingStopLimitOrder.buy === 0;
    let avgPrice = item.exchangeTrailingStopLimitOrder.average_buy_price;
    if (!avgPrice) {
        avgPrice = item.exchangeTrailingStopLimitOrder.buy;
    }
    let buyAmount = item.exchangeTrailingStopLimitOrder.buy_amount;
    if (!buyAmount) {
        buyAmount = 0;
    }
    let profit = 0;
    let invest = 0;
    let isRunning = item.state === "submitted" || item.state === "canceling";
    if (haveBase) {
        invest = item.exchangeTrailingStopLimitOrder.trigger * item.exchangeTrailingStopLimitOrder.amount;
    }
    else {
        if (buyAmount > 0) {
            invest = avgPrice * buyAmount;
        }
        else {
            invest = item.exchangeTrailingStopLimitOrder.buy * item.exchangeTrailingStopLimitOrder.amount;
        }
    }
    if (isRunning) {
        if (haveBase) {
            if (item.exchangeTrailingStopLimitOrder.state === "state_stop_price_test") {
                profit = item.exchangeTrailingStopLimitOrder.amount * item.exchangeTrailingStopLimitOrder.latestPrice - invest;
            }
        }
        else {
            if (buyAmount > 0) {
                profit = item.exchangeTrailingStopLimitOrder.latestPrice * buyAmount - invest;
            }
            else {
                profit = 0;
            }
        }
    }
    else {
        profit = item.exchangeTrailingStopLimitOrder.trailing_stop_profit;
    }
    item.exchangeTrailingStopLimitOrder.investment = invest;
    item.exchangeTrailingStopLimitOrder.profit = profit;
    return item;
}
exports._calcTrailingStopProfit = _calcTrailingStopProfit;
/**
 * smart trade 利润计算
 * @param item
 * @param price
 * @private
 */
function _calcSmartTradeProfit(item, price) {
    item.exchangeSmartTradeOrder.latestPrice = price;
    if (item.exchangeSmartTradeOrder.smartType === TradeTypeDef_1.SmartTradeType.smart_trade_buy_only) {
        if (item.isRunning) {
            if (price !== 0 && item.exchangeSmartTradeOrder.buy !== 0) {
                item.exchangeSmartTradeOrder.profit =
                    item.exchangeSmartTradeOrder.amount / price - item.exchangeSmartTradeOrder.amount / item.exchangeSmartTradeOrder.buy;
                item.exchangeSmartTradeOrder.profitPercent =
                    (item.exchangeSmartTradeOrder.profit * 100) / (item.exchangeSmartTradeOrder.amount / item.exchangeSmartTradeOrder.buy);
            }
        }
        else {
            if (item.exchangeSmartTradeOrder.buy !== 0) {
                item.exchangeSmartTradeOrder.profit =
                    item.exchangeSmartTradeOrder.buyAmountFilled -
                        item.exchangeSmartTradeOrder.amount / item.exchangeSmartTradeOrder.buy;
                item.exchangeSmartTradeOrder.profitPercent =
                    (item.exchangeSmartTradeOrder.profit * 100) / (item.exchangeSmartTradeOrder.amount / item.exchangeSmartTradeOrder.buy);
            }
        }
    }
    else {
        if (item.exchangeSmartTradeOrder.buyAmountFilled !== undefined) {
            if (item.isRunning) {
                if (item.exchangeSmartTradeOrder.buyCost !== undefined) {
                    item.exchangeSmartTradeOrder.profit =
                        item.exchangeSmartTradeOrder.buyAmountFilled * price - item.exchangeSmartTradeOrder.buyCost;
                }
                else {
                    item.exchangeSmartTradeOrder.profit =
                        item.exchangeSmartTradeOrder.buyAmountFilled * price +
                            (item.exchangeSmartTradeOrder.amount - item.exchangeSmartTradeOrder.buyAmountFilled) *
                                item.exchangeSmartTradeOrder.buy -
                            item.exchangeSmartTradeOrder.totalInvest;
                }
                item.exchangeSmartTradeOrder.profitPercent =
                    (item.exchangeSmartTradeOrder.profit * 100) / item.exchangeSmartTradeOrder.totalInvest;
            }
            else {
                if (item.exchangeSmartTradeOrder.sellPrice) {
                    if (item.exchangeSmartTradeOrder.buyCost !== undefined) {
                        item.exchangeSmartTradeOrder.profit =
                            item.exchangeSmartTradeOrder.buyAmountFilled * item.exchangeSmartTradeOrder.sellPrice -
                                item.exchangeSmartTradeOrder.buyCost;
                    }
                    else {
                        item.exchangeSmartTradeOrder.profit =
                            item.exchangeSmartTradeOrder.buyAmountFilled * item.exchangeSmartTradeOrder.sellPrice +
                                (item.exchangeSmartTradeOrder.amount - item.exchangeSmartTradeOrder.buyAmountFilled) *
                                    item.exchangeSmartTradeOrder.buy -
                                item.exchangeSmartTradeOrder.totalInvest;
                    }
                    item.exchangeSmartTradeOrder.profitPercent =
                        (item.exchangeSmartTradeOrder.profit * 100) / item.exchangeSmartTradeOrder.totalInvest;
                }
            }
        }
    }
    return item;
}
exports._calcSmartTradeProfit = _calcSmartTradeProfit;
/**
 * 计算fsa订单利润
 * @param item
 * @param price
 * @param swapPrice
 浮动利润 = (spot_ticker - spot_open_price) * spot_position + (swap_ticker - swap_open_price) * swap_position
 累计费用 = spot_realized_pnl + swap_realized_pnl + insurance_fee - spot_fee - swap_fee - insurance_deduct_total - strategy_deduct_total
 累计总利润 = 套利利润 + 浮动利润 + 累计费用
 */
function _calcFSAProfit(item, price, swapPrice) {
    let tempUnRealizedProfit = 0;
    if (item.isRunning && swapPrice !== undefined && swapPrice !== 0 && price !== 0) {
        tempUnRealizedProfit =
            (price - item.exchangeFSAOrder.spotOpenPrice) * item.exchangeFSAOrder.spotPosition +
                (swapPrice - item.exchangeFSAOrder.swapOpenPrice) * item.exchangeFSAOrder.swapPosition;
    }
    item.exchangeFSAOrder.accumulatedFee =
        item.exchangeFSAOrder.spotRealizedPnl +
            item.exchangeFSAOrder.swapRealizedPnl +
            item.exchangeFSAOrder.insuranceFee -
            item.exchangeFSAOrder.spotFee -
            item.exchangeFSAOrder.swapFee -
            item.exchangeFSAOrder.insuranceDeductTotal -
            item.exchangeFSAOrder.strategyDeductTotal;
    item.exchangeFSAOrder.unRealizedProfit = tempUnRealizedProfit;
    item.exchangeFSAOrder.totalProfit =
        item.exchangeFSAOrder.gridProfit + item.exchangeFSAOrder.unRealizedProfit + item.exchangeFSAOrder.accumulatedFee;
    item.exchangeFSAOrder.gridProfitPercent = (item.exchangeFSAOrder.gridProfit / item.exchangeFSAOrder.investment) * 100;
    item.exchangeFSAOrder.unrealizedProfitPercent = (item.exchangeFSAOrder.unRealizedProfit / item.exchangeFSAOrder.investment) * 100;
    item.exchangeFSAOrder.totalProfitPercent = (item.exchangeFSAOrder.totalProfit / item.exchangeFSAOrder.investment) * 100;
    return item;
}
exports._calcFSAProfit = _calcFSAProfit;
/**
 * CMFSA 订单计算利润
 * @param item
 * @param price
 * @param swapPrice
 *套利利润 =  realized_funding_fee_value + (total_funding_fee - realized_funding_fee) * current_price
 *浮动利润 = (spot_ticker - spot_open_price) * spot_position + (swap_ticker - swap_open_price) * swap_position * (spot_ticker/swap_ticker)
 累计费用 =  - spot_fee - swap_fee
 累计总利润 = 套利利润 + 浮动利润 + 累计费用
 */
function _calcCMFSAProfit(item, price, swapPrice) {
    var _a, _b, _c, _d, _e, _f;
    let tempUnRealizedProfit = 0;
    if (item.isRunning && swapPrice !== undefined && swapPrice !== 0 && price !== 0) {
        tempUnRealizedProfit =
            (price - item.exchangeCMFSAOrder.spotOpenPrice) * item.exchangeCMFSAOrder.spotPosition +
                (swapPrice - item.exchangeCMFSAOrder.swapOpenPrice) * item.exchangeCMFSAOrder.swapPosition * (price / swapPrice);
    }
    item.exchangeCMFSAOrder.profit =
        Number(item.exchangeCMFSAOrder.realizedFundingFeeValue) +
            (item.exchangeCMFSAOrder.totalFundingFee - Number(item.exchangeCMFSAOrder.realizedFundingFee)) * price;
    item.exchangeCMFSAOrder.annualizedReturn_1day =
        Number((_a = item.exchangeCMFSAOrder.investment) !== null && _a !== void 0 ? _a : 0) === 0
            ? 0
            : ((Number((_b = item.exchangeCMFSAOrder.average_1day) !== null && _b !== void 0 ? _b : 0) * price * 365 * 3) / Number(item.exchangeCMFSAOrder.investment)) * 100;
    item.exchangeCMFSAOrder.annualizedReturn_7days =
        Number((_c = item.exchangeCMFSAOrder.investment) !== null && _c !== void 0 ? _c : 0) === 0
            ? 0
            : ((Number((_d = item.exchangeCMFSAOrder.average_7days) !== null && _d !== void 0 ? _d : 0) * price * 365 * 3) / Number(item.exchangeCMFSAOrder.investment)) * 100;
    let annualizedReturn_30daysValue = 0;
    if (Number((_e = item.exchangeCMFSAOrder.fundingFeeTimes) !== null && _e !== void 0 ? _e : 0) !== 0 && Number((_f = item.exchangeCMFSAOrder.investment) !== null && _f !== void 0 ? _f : 0) !== 0) {
        annualizedReturn_30daysValue =
            ((((Number(item.exchangeCMFSAOrder.totalFundingFee) * price) / Number(item.exchangeCMFSAOrder.fundingFeeTimes)) * 365 * 3) /
                Number(item.exchangeCMFSAOrder.investment)) *
                100;
    }
    item.exchangeCMFSAOrder.annualizedReturn_30days = annualizedReturn_30daysValue;
    item.exchangeCMFSAOrder.annualizedReturn_30days = annualizedReturn_30daysValue;
    item.exchangeCMFSAOrder.accumulatedFee = -(item.exchangeCMFSAOrder.spotFee + item.exchangeCMFSAOrder.swapFee);
    item.exchangeCMFSAOrder.unRealizedProfit = tempUnRealizedProfit;
    item.exchangeCMFSAOrder.totalProfit =
        item.exchangeCMFSAOrder.profit + item.exchangeCMFSAOrder.unRealizedProfit + item.exchangeCMFSAOrder.accumulatedFee;
    item.exchangeCMFSAOrder.profitPercent = (item.exchangeCMFSAOrder.profit / item.exchangeCMFSAOrder.investment) * 100;
    item.exchangeCMFSAOrder.unrealizedProfitPercent = (item.exchangeCMFSAOrder.unRealizedProfit / item.exchangeCMFSAOrder.investment) * 100;
    item.exchangeCMFSAOrder.totalProfitPercent = (item.exchangeCMFSAOrder.totalProfit / item.exchangeCMFSAOrder.investment) * 100;
    return item;
}
exports._calcCMFSAProfit = _calcCMFSAProfit;
/**
 * reverse_fsa 订单计算利润
 * @param item
 * @param spotPrice
 * @param swapPrice
 *
 反向期现套利数据计算公式：

 总资产 = investment + spot_realized_pnl_in_base + swap_realized_pnl_in_base + funding_fee_in_base - spot_fee - swap_fee + spot_realized_pnl + swap_realized_pnl
 总利润 = spot_realized_pnl_in_base + swap_realized_pnl_in_base + funding_fee_in_base - spot_fee - swap_fee + spot_realized_pnl + swap_realized_pnl
 套利利润 = realized_funding_fee_value + (total_funding_fee - realized_funding_fee) / spot_current_price
 手续费 = - spot_fee - swap_fee
 浮动利润 = (spot_current_price - spot_open_price) * spot_position / spot_current_price + (swap_current_price - swap_open_price) * swap_position / spot_current_price

 spot_realized_pnl_in_base = (spot_current_price - spot_open_price) * spot_position / spot_current_price
 swap_realized_pnl_in_base = (swap_current_price - swap_open_price) * swap_position / spot_current_price
 funding_fee_in_base = realized_funding_fee_value + (total_funding_fee - realized_funding_fee) / spot_current_price
 */
function _calcReverseFSAProfit(item, spotPrice, swapPrice) {
    var _a, _b, _c, _d, _e, _f;
    item.exchangeReverseFSAOrder.annualizedReturn_1day =
        Number((_a = item.exchangeReverseFSAOrder.investment) !== null && _a !== void 0 ? _a : 0) === 0
            ? 0
            : ((Number((_b = item.exchangeReverseFSAOrder.average_1day) !== null && _b !== void 0 ? _b : 0) * spotPrice * 365 * 3) /
                Number(item.exchangeReverseFSAOrder.investment)) *
                100;
    item.exchangeReverseFSAOrder.annualizedReturn_7days =
        Number((_c = item.exchangeReverseFSAOrder.investment) !== null && _c !== void 0 ? _c : 0) === 0
            ? 0
            : ((Number((_d = item.exchangeReverseFSAOrder.average_7days) !== null && _d !== void 0 ? _d : 0) * spotPrice * 365 * 3) /
                Number(item.exchangeReverseFSAOrder.investment)) *
                100;
    let annualizedReturn_30daysValue = 0;
    if (Number((_e = item.exchangeReverseFSAOrder.fundingFeeTimes) !== null && _e !== void 0 ? _e : 0) !== 0 && Number((_f = item.exchangeReverseFSAOrder.investment) !== null && _f !== void 0 ? _f : 0) !== 0) {
        annualizedReturn_30daysValue =
            ((((Number(item.exchangeReverseFSAOrder.totalFundingFee) * spotPrice) / Number(item.exchangeReverseFSAOrder.fundingFeeTimes)) *
                365 *
                3) /
                Number(item.exchangeReverseFSAOrder.investment)) *
                100;
    }
    item.exchangeReverseFSAOrder.annualizedReturn_30days = annualizedReturn_30daysValue;
    item.exchangeReverseFSAOrder.annualizedReturn_30days = annualizedReturn_30daysValue;
    item.exchangeReverseFSAOrder.accumulatedFee = -(item.exchangeReverseFSAOrder.spotFee + item.exchangeReverseFSAOrder.swapFee);
    let spotRealizedPnlInBase = 0;
    let swapRealizedPnlInBase = 0;
    let fundingFeeInBase = 0;
    let tempUnRealizedProfit = 0;
    if (spotPrice !== 0) {
        fundingFeeInBase = new trade_utils_lib_1.SafeDecimal(item.exchangeReverseFSAOrder.realizedFundingFeeValue)
            .add(new trade_utils_lib_1.SafeDecimal(item.exchangeReverseFSAOrder.totalFundingFee)
            .sub(new trade_utils_lib_1.SafeDecimal(item.exchangeReverseFSAOrder.realizedFundingFee))
            .div(new trade_utils_lib_1.SafeDecimal(spotPrice)))
            .toNumber();
        item.exchangeReverseFSAOrder.profit = fundingFeeInBase;
    }
    if (item.isRunning) {
        if (spotPrice !== 0 && swapPrice !== undefined && swapPrice !== 0) {
            spotRealizedPnlInBase = new trade_utils_lib_1.SafeDecimal(spotPrice)
                .sub(new trade_utils_lib_1.SafeDecimal(item.exchangeReverseFSAOrder.spotOpenPrice))
                .mul(item.exchangeReverseFSAOrder.spotPosition)
                .div(new trade_utils_lib_1.SafeDecimal(spotPrice))
                .toNumber();
            swapRealizedPnlInBase = new trade_utils_lib_1.SafeDecimal(swapPrice)
                .sub(new trade_utils_lib_1.SafeDecimal(item.exchangeReverseFSAOrder.swapOpenPrice))
                .mul(item.exchangeReverseFSAOrder.swapPosition)
                .div(new trade_utils_lib_1.SafeDecimal(spotPrice))
                .toNumber();
            tempUnRealizedProfit = spotRealizedPnlInBase + swapRealizedPnlInBase;
            item.exchangeReverseFSAOrder.totalProfit =
                tempUnRealizedProfit +
                    fundingFeeInBase +
                    item.exchangeReverseFSAOrder.accumulatedFee +
                    item.exchangeReverseFSAOrder.spotRealizedPnl +
                    item.exchangeReverseFSAOrder.swapRealizedPnl;
        }
    }
    else {
        tempUnRealizedProfit = spotRealizedPnlInBase + swapRealizedPnlInBase;
        item.exchangeReverseFSAOrder.totalProfit =
            tempUnRealizedProfit +
                fundingFeeInBase +
                item.exchangeReverseFSAOrder.accumulatedFee +
                item.exchangeReverseFSAOrder.spotRealizedPnl +
                item.exchangeReverseFSAOrder.swapRealizedPnl;
    }
    item.exchangeReverseFSAOrder.unRealizedProfit = tempUnRealizedProfit;
    item.exchangeReverseFSAOrder.profitPercent = (item.exchangeReverseFSAOrder.profit / item.exchangeReverseFSAOrder.investment) * 100;
    item.exchangeReverseFSAOrder.unrealizedProfitPercent =
        (item.exchangeReverseFSAOrder.unRealizedProfit / item.exchangeReverseFSAOrder.investment) * 100;
    item.exchangeReverseFSAOrder.totalProfitPercent =
        (item.exchangeReverseFSAOrder.totalProfit / item.exchangeReverseFSAOrder.investment) * 100;
    return item;
}
exports._calcReverseFSAProfit = _calcReverseFSAProfit;
/**
 * 计算Smart_rebalance 订单利润
 * @param item
 * @param basesTickers
 */
function _calcSRProfit(item, basesTickers) {
    item.exchangeSROrder.profitPercent = (item.exchangeSROrder.profit / item.exchangeSROrder.totalInvest) * 100;
    if (item.isRunning) {
        if (basesTickers === undefined) {
            return item;
        }
        else {
            const hasBaseAmountCoins = item.exchangeSROrder.coins.filter((coin) => coin.currentBaseAmount !== 0);
            const map = new Map(basesTickers.map((ticker) => [`${ticker.exchange}/${ticker.base}/${ticker.quote}`, ticker]));
            const isFull = hasBaseAmountCoins.every((coin) => coin.base === item.quote || map.has(`${item.exchange}/${coin.base}/${item.quote}`));
            if (isFull) {
                item.exchangeSROrder.unRealizedProfit = hasBaseAmountCoins.reduce((sum, coin) => {
                    if (coin.base === item.quote) {
                        return sum + coin.currentBaseAmount;
                    }
                    else {
                        const tempTicker = basesTickers.find((item2) => coin.base === item2.base);
                        if (tempTicker !== undefined) {
                            return sum + tempTicker.latest * coin.currentBaseAmount;
                        }
                        else {
                            return sum;
                        }
                    }
                }, 0);
                item.exchangeSROrder.totalProfit =
                    item.exchangeSROrder.unRealizedProfit + item.exchangeSROrder.currentQuoteAmount - item.exchangeSROrder.totalInvest;
                item.exchangeSROrder.totalProfitPercent = (item.exchangeSROrder.totalProfit / item.exchangeSROrder.totalInvest) * 100;
            }
            item.exchangeSROrder.unrealizedProfitPercent = (item.exchangeSROrder.unRealizedProfit / item.exchangeSROrder.totalInvest) * 100;
            return item;
        }
    }
    else {
        item.exchangeSROrder.totalProfit =
            item.exchangeSROrder.coins.reduce((sum, item1) => {
                return sum + (item1.closePrice || 0) * item1.closeBaseAmount;
            }, 0) +
                item.exchangeSROrder.closedQuoteAmount -
                item.exchangeSROrder.totalInvest;
        item.exchangeSROrder.unRealizedProfit = item.exchangeSROrder.totalProfit - item.exchangeSROrder.profit;
        item.exchangeSROrder.unrealizedProfitPercent = (item.exchangeSROrder.unRealizedProfit / item.exchangeSROrder.totalInvest) * 100;
        item.exchangeSROrder.totalProfitPercent = (item.exchangeSROrder.totalProfit / item.exchangeSROrder.totalInvest) * 100;
        return item;
    }
}
exports._calcSRProfit = _calcSRProfit;
/**
 *
 * @param item
 * @param basesTickers
 */
function _calcMTGProfit(item, basesTickers) {
    if (item.isRunning) {
        if (basesTickers === undefined) {
            return item;
        }
        else {
            if (basesTickers.length === item.exchangeMTGOrder.coins.length) {
                const currentValue = item.exchangeMTGOrder.coins.reduce((sum, item1) => {
                    const tempTicker = basesTickers.find((item2) => item1.base === item2.base);
                    if (tempTicker !== undefined) {
                        return sum + tempTicker.latest * item1.currentBaseAmount;
                    }
                    else {
                        return sum;
                    }
                }, item.exchangeMTGOrder.currentQuoteAmount);
                item.exchangeMTGOrder.totalProfit = currentValue === 0 ? 0 : currentValue - item.exchangeMTGOrder.totalInvest;
            }
            item.exchangeMTGOrder.unRealizedProfit = item.exchangeMTGOrder.totalProfit - item.exchangeMTGOrder.profit;
            item.exchangeMTGOrder.profitPercent = (item.exchangeMTGOrder.profit / item.exchangeMTGOrder.totalInvest) * 100;
            item.exchangeMTGOrder.unrealizedProfitPercent =
                (item.exchangeMTGOrder.unRealizedProfit / item.exchangeMTGOrder.totalInvest) * 100;
            item.exchangeMTGOrder.totalProfitPercent = (item.exchangeMTGOrder.totalProfit / item.exchangeMTGOrder.totalInvest) * 100;
            return item;
        }
    }
    else {
        item.exchangeMTGOrder.totalProfit =
            item.exchangeMTGOrder.coins.reduce((sum, item1) => {
                return sum + (item1.closePrice || 0) * item1.currentBaseAmount;
            }, item.exchangeMTGOrder.currentQuoteAmount) - item.exchangeMTGOrder.totalInvest;
        item.exchangeMTGOrder.unRealizedProfit = item.exchangeMTGOrder.totalProfit - item.exchangeMTGOrder.profit;
        item.exchangeMTGOrder.profitPercent = (item.exchangeMTGOrder.profit / item.exchangeMTGOrder.totalInvest) * 100;
        item.exchangeMTGOrder.unrealizedProfitPercent = (item.exchangeMTGOrder.unRealizedProfit / item.exchangeMTGOrder.totalInvest) * 100;
        item.exchangeMTGOrder.totalProfitPercent = (item.exchangeMTGOrder.totalProfit / item.exchangeMTGOrder.totalInvest) * 100;
        return item;
    }
}
exports._calcMTGProfit = _calcMTGProfit;
/**
 * @param item
 * @param basesTickers
 */
function _calcSCProfit(item, basesTickers) {
    if (item.isRunning) {
        if (basesTickers === undefined) {
            return item;
        }
        else {
            if (basesTickers.length === item.exchangeSCOrder.coins.length) {
                const currentValue = (() => {
                    try {
                        return item.exchangeSCOrder.coins.reduce((sum, item1) => {
                            const tempTicker = basesTickers.find((item2) => item1.base === item2.base);
                            if (tempTicker === undefined) {
                                return sum;
                            }
                            if (item.exchangeSCOrder.market === "perpFutures") {
                                /**
                                 * 历史订单 current_quote_amount - quote_total_investment
                                 */
                                if ([TradeTypeDef_1.ExchangeOrderStatus.closed, TradeTypeDef_1.ExchangeOrderStatus.canceled].includes(item.state)) {
                                    return Number(sum);
                                }
                                /**
                                 * 运行中订单
                                 * 计算 smart_copy 中的 perpFutures 总利润
                                 * = 当前市值-投资额  // 标记价格取不到就取现货价格
                                 * = current_quote_amount + (qty_long+qty_short)*标记价格 + (amount_long+amount_short)-quote_total_investment
                                 *
                                 * */
                                return new trade_utils_lib_1.SafeDecimal(tempTicker.latest)
                                    .mul(new trade_utils_lib_1.SafeDecimal(item1.qty_long).add(item1.qty_short))
                                    .add(item1.amount_long)
                                    .add(item1.amount_short)
                                    .add(sum)
                                    .toNumber();
                            }
                            return new trade_utils_lib_1.SafeDecimal(tempTicker.latest).mul(item1.currentBaseAmount).add(sum).toNumber();
                        }, item.exchangeSCOrder.currentQuoteAmount);
                    }
                    catch (error) {
                        return 0;
                    }
                })();
                item.exchangeSCOrder.totalProfit = currentValue === 0 ? 0 : currentValue - item.exchangeSCOrder.totalInvest;
            }
            //容错服务端内外层profit 字段值不统一bug
            const coinProfitValue = item.exchangeSCOrder.coins.reduce((sum, item1) => {
                return sum + item1.profit;
            }, 0);
            item.exchangeSCOrder.unRealizedProfit = item.exchangeSCOrder.totalProfit - coinProfitValue;
            item.exchangeSCOrder.profit = coinProfitValue;
            item.exchangeSCOrder.profitPercent = (item.exchangeSCOrder.profit / item.exchangeSCOrder.totalInvest) * 100;
            item.exchangeSCOrder.unrealizedProfitPercent = (item.exchangeSCOrder.unRealizedProfit / item.exchangeSCOrder.totalInvest) * 100;
            item.exchangeSCOrder.totalProfitPercent = (item.exchangeSCOrder.totalProfit / item.exchangeSCOrder.totalInvest) * 100;
            return item;
        }
    }
    else {
        item.exchangeSCOrder.totalProfit =
            item.exchangeSCOrder.coins.reduce((sum, item1) => {
                return sum + (item1.closePrice || 0) * item1.currentBaseAmount;
            }, item.exchangeSCOrder.currentQuoteAmount) - item.exchangeSCOrder.totalInvest;
        const coinProfitValue = item.exchangeSCOrder.coins.reduce((sum, item1) => {
            return sum + item1.profit;
        }, 0);
        item.exchangeSCOrder.unRealizedProfit = item.exchangeSCOrder.totalProfit - coinProfitValue;
        item.exchangeSCOrder.profit = coinProfitValue;
        item.exchangeSCOrder.profitPercent = (item.exchangeSCOrder.profit / item.exchangeSCOrder.totalInvest) * 100;
        item.exchangeSCOrder.unrealizedProfitPercent = (item.exchangeSCOrder.unRealizedProfit / item.exchangeSCOrder.totalInvest) * 100;
        item.exchangeSCOrder.totalProfitPercent = (item.exchangeSCOrder.totalProfit / item.exchangeSCOrder.totalInvest) * 100;
        return item;
    }
}
exports._calcSCProfit = _calcSCProfit;
/**
 *
 * @param item
 * @param basesTickers
 */
function _calcEnhancedAipProfit(item, basesTickers) {
    if (item.isRunning) {
        if (basesTickers === undefined) {
            return item;
        }
        else {
            if (basesTickers.length === item.exchangeEnhancedAipOrder.coins.length) {
                const currentCoinsValue = item.exchangeEnhancedAipOrder.coins.reduce((sum, item1) => {
                    const tempTicker = basesTickers.find((item2) => item1.base === item2.base);
                    if (tempTicker !== undefined) {
                        return sum + tempTicker.latest * item1.currentBaseAmount;
                    }
                    else {
                        return sum;
                    }
                }, item.exchangeEnhancedAipOrder.currentQuoteAmount);
                item.exchangeEnhancedAipOrder.totalProfit =
                    currentCoinsValue === 0 ? 0 : currentCoinsValue - item.exchangeEnhancedAipOrder.investment;
                item.exchangeEnhancedAipOrder.totalProfitPercent =
                    (item.exchangeEnhancedAipOrder.totalProfit / item.exchangeEnhancedAipOrder.investment) * 100;
                item.exchangeEnhancedAipOrder.profit = item.exchangeEnhancedAipOrder.coins.reduce((sum, item1) => {
                    return sum + item1.stakingProfit;
                }, 0);
                const coinProfitValue = item.exchangeEnhancedAipOrder.coins.reduce((sum, item1) => {
                    const tempTicker = basesTickers.find((item2) => item1.base === item2.base);
                    if (tempTicker !== undefined) {
                        return sum + tempTicker.latest * item1.stakingProfit;
                    }
                    else {
                        return sum;
                    }
                }, 0);
                item.exchangeEnhancedAipOrder.profitPercent = (coinProfitValue / item.exchangeEnhancedAipOrder.investment) * 100;
                item.exchangeEnhancedAipOrder.unRealizedProfit = item.exchangeEnhancedAipOrder.totalProfit - coinProfitValue;
                item.exchangeEnhancedAipOrder.unrealizedProfitPercent =
                    (item.exchangeEnhancedAipOrder.unRealizedProfit / item.exchangeEnhancedAipOrder.investment) * 100;
            }
            return item;
        }
    }
    else {
        item.exchangeEnhancedAipOrder.totalProfit =
            item.exchangeEnhancedAipOrder.coins.reduce((sum, item1) => {
                return sum + (item1.closePrice || 0) * item1.currentBaseAmount;
            }, item.exchangeEnhancedAipOrder.currentQuoteAmount) - item.exchangeEnhancedAipOrder.investment;
        const coinProfitCount = item.exchangeEnhancedAipOrder.coins.reduce((sum, item1) => {
            return sum + item1.stakingProfit;
        }, 0);
        item.exchangeEnhancedAipOrder.profit = coinProfitCount;
        const coinProfitValue = item.exchangeEnhancedAipOrder.coins.reduce((sum, item1) => {
            return sum + (item1.closePrice || 0) * item1.stakingProfit;
        }, 0);
        item.exchangeEnhancedAipOrder.profitPercent = (coinProfitValue / item.exchangeEnhancedAipOrder.investment) * 100;
        item.exchangeEnhancedAipOrder.unRealizedProfit = item.exchangeEnhancedAipOrder.totalProfit - coinProfitValue;
        item.exchangeEnhancedAipOrder.unrealizedProfitPercent =
            (item.exchangeEnhancedAipOrder.unRealizedProfit / item.exchangeEnhancedAipOrder.investment) * 100;
        item.exchangeEnhancedAipOrder.totalProfitPercent =
            (item.exchangeEnhancedAipOrder.totalProfit / item.exchangeEnhancedAipOrder.investment) * 100;
        return item;
    }
}
exports._calcEnhancedAipProfit = _calcEnhancedAipProfit;
// 网格利润:grid_profit
// 已提取网格利润:profit_withdrawn
// 累计总利润: profit_withdrawn + (quote_amount+base_amount*cur_price) -(quote_total_investment+base_total_investment*open_price)
// 浮动盈亏: 总利润-网格利润
// 当前可提取 = 网格利润 - 已提取网格利润
function _calcGridV4Profit(item, innerStatus, price) {
    item.latestPrice = price;
    if (!(item.totalCost === 0 || price === 0 || innerStatus === TradeTypeDef_1.OrderInnerStatus.lockCurrency)) {
        item.totalProfit = item.baseAmount * price + item.quoteAmount - item.totalCost;
    }
    item.gridProfit = new trade_utils_lib_1.SafeDecimal(item.gridProfitOriginal).sub(new trade_utils_lib_1.SafeDecimal(item.profitWithdrawn)).toNumber();
    item.unRealizedProfit = item.totalProfit - item.gridProfit;
    item.gridProfitPercent = item.totalCost === 0 ? 0 : (item.gridProfit * 100) / item.totalCost;
    item.unrealizedProfitPercent = item.totalCost === 0 ? 0 : (item.unRealizedProfit * 100) / item.totalCost;
    item.totalProfitPercent = item.totalCost === 0 ? 0 : (item.totalProfit * 100) / item.totalCost;
    return item;
}
exports._calcGridV4Profit = _calcGridV4Profit;
